const initialState = { 
  loading: false,
  success: null,
  error: null
}

function updateAgentReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_AGENT_DROPSHIP_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'UPDATE_AGENT_DROPSHIP_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'UPDATE_AGENT_DROPSHIP_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default updateAgentReducer